import Strings from "../../../../Strings";
import { getComponentVariableCategories, getComponentVariableImportance, isComponentVariableExplicitlyCategorized, isComponentVariableTranslatable, isComponentVariableUIDisplayOnly, } from "../../../../tags/component-variables";
const hardCodedUIDisplayOnlyVariableNames = new Set(["variants"]);
const advancedImportanceLevels = "ADVANCED";
const expertImportanceLevels = "EXPERT";
export class BuiltCampaignComponentSetting {
    constructor(response, context) {
        this.context = context;
        this.name = response.name;
        this.display_name = response.display_name;
        this.type = response.type;
        this.tags = [...response.tags];
        this.priority = response.priority;
        const { primary, secondary } = getComponentVariableCategories(this.type, this.tags);
        this.primaryCategory = primary;
        this.secondaryCategory = secondary;
    }
    getDisplayName() {
        if (this.display_name !== null) {
            return this.display_name;
        }
        return Strings.capitalizeCamelCase(this.name);
    }
    getDescription() {
        // This is currently not available in the API response
        return null;
    }
    getPrimaryCategory() {
        return this.primaryCategory || "other";
    }
    getSecondaryCategory() {
        return this.secondaryCategory || "other";
    }
    isUIDisplayOnly() {
        if (hardCodedUIDisplayOnlyVariableNames.has(this.name)) {
            return true;
        }
        return isComponentVariableUIDisplayOnly(this.tags);
    }
    getImportance() {
        return getComponentVariableImportance(this.tags);
    }
    isTranslatable() {
        return isComponentVariableTranslatable(this.tags);
    }
    isExplicitlyCategorized() {
        return isComponentVariableExplicitlyCategorized(this.tags);
    }
    isHidden() {
        return this.getImportance() === expertImportanceLevels;
    }
    isAdvanced() {
        return this.getImportance() === advancedImportanceLevels;
    }
}
